/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDeploymentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetDeploymentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetDeploymentSecurity = {
  option1?: GetDeploymentSecurityOption1 | undefined;
  option2?: GetDeploymentSecurityOption2 | undefined;
};

export type GetDeploymentRequest = {
  /**
   * The ID of the deployment
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetDeploymentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetDeploymentSecurityOption1$outboundSchema: z.ZodMiniType<
  GetDeploymentSecurityOption1$Outbound,
  GetDeploymentSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getDeploymentSecurityOption1ToJSON(
  getDeploymentSecurityOption1: GetDeploymentSecurityOption1,
): string {
  return JSON.stringify(
    GetDeploymentSecurityOption1$outboundSchema.parse(
      getDeploymentSecurityOption1,
    ),
  );
}

/** @internal */
export type GetDeploymentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetDeploymentSecurityOption2$outboundSchema: z.ZodMiniType<
  GetDeploymentSecurityOption2$Outbound,
  GetDeploymentSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDeploymentSecurityOption2ToJSON(
  getDeploymentSecurityOption2: GetDeploymentSecurityOption2,
): string {
  return JSON.stringify(
    GetDeploymentSecurityOption2$outboundSchema.parse(
      getDeploymentSecurityOption2,
    ),
  );
}

/** @internal */
export type GetDeploymentSecurity$Outbound = {
  Option1?: GetDeploymentSecurityOption1$Outbound | undefined;
  Option2?: GetDeploymentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetDeploymentSecurity$outboundSchema: z.ZodMiniType<
  GetDeploymentSecurity$Outbound,
  GetDeploymentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetDeploymentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetDeploymentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getDeploymentSecurityToJSON(
  getDeploymentSecurity: GetDeploymentSecurity,
): string {
  return JSON.stringify(
    GetDeploymentSecurity$outboundSchema.parse(getDeploymentSecurity),
  );
}

/** @internal */
export type GetDeploymentRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetDeploymentRequest$outboundSchema: z.ZodMiniType<
  GetDeploymentRequest$Outbound,
  GetDeploymentRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getDeploymentRequestToJSON(
  getDeploymentRequest: GetDeploymentRequest,
): string {
  return JSON.stringify(
    GetDeploymentRequest$outboundSchema.parse(getDeploymentRequest),
  );
}
